export default __webpack_public_path__ + "static/media/bg-locaticia-produto.98430de7.webp";